enum OAuthStep {
  LANDING_PAGE = 1,
  SIGN_IN,
  SIGN_UP,
  EXTERNAL_APPLICATION,
  CERTIFICATION,
  ACCOUNT_TYPE,
  PAYMENT,
  AUTHORIZATION,
  OIDC_SIGN_UP,
  OIDC_NOT_FOUND,
}

export { OAuthStep };
